import { render, staticRenderFns } from "./Enterate-component.vue?vue&type=template&id=5b799e45&scoped=true"
import script from "./Enterate-component.vue?vue&type=script&lang=js"
export * from "./Enterate-component.vue?vue&type=script&lang=js"
import style0 from "./Enterate-component.vue?vue&type=style&index=0&id=5b799e45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b799e45",
  null
  
)

export default component.exports